package com.anjuros.website.templates.template5.modules

import com.anjuros.website.templates.template5.util.ResKey

enum class Template5FAQ(

    val question: ResKey,
    val answer: ResKey

) {

    FAQ1(
        ResKey.TEMPLATE5_FAQ1_Q,
        ResKey.TEMPLATE5_FAQ1_A
    ),

    FAQ2(
        ResKey.TEMPLATE5_FAQ2_Q,
        ResKey.TEMPLATE5_FAQ2_A
    ),

    FAQ3(
        ResKey.TEMPLATE5_FAQ3_Q,
        ResKey.TEMPLATE5_FAQ3_A
    ),

    FAQ4(
        ResKey.TEMPLATE5_FAQ4_Q,
        ResKey.TEMPLATE5_FAQ4_A
    ),

    FAQ5(
        ResKey.TEMPLATE5_FAQ5_Q,
        ResKey.TEMPLATE5_FAQ5_A
    )

}